import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { createConnector, InferConnectedProps } from '../../redux/createConnector'
import { isSidebarOpen } from '../../redux/profile/selectors'
import Loader, { IProps } from './Loader'

const selector = createStructuredSelector({
  isSidebarOpen,
})

const connector = connect(selector)
/* eslint-disable @typescript-eslint/no-empty-object-type */
export type PropsFromRedux = InferConnectedProps<typeof connector, {}>
export default createConnector<typeof connector, IProps, PropsFromRedux>(connector, Loader)
